import { DISABLED_OPACITY } from "../../../styles/colors/consts";

export default function getLinkStyles(disabled: boolean) {
  if (disabled) {
    return {
      textDecoration: "none",
      cursor: "not-allowed",
      opacity: DISABLED_OPACITY
    };
  }

  return {
    textDecoration: "none",
    hoverStyles: {
      textDecoration: "underline"
    },
    activeStyles: {
      textDecoration: "underline"
    },
    activeNavLinkStyles: {
      textDecoration: "underline"
    }
  };
}
